import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../utils/api'
import { RootState } from '../../rootReducer'

interface SyncResponse {
  result: {
    status: string
    deleteDuration: string
    insertDuration: string
    totalDuration: string
  }
}

// Ejecuta el proceso de sincronización de los datos del central
export const getSync = createAsyncThunk<SyncResponse, void>('attendanceReport/getSync', async (_, { rejectWithValue, getState }) => {
  try {
    const state = getState() as RootState

    const token = localStorage.getItem('token')
    const headers = new Headers()
    headers.append('Authorization', `Bearer ${token}`)
    headers.append('Content-Type', 'application/json')

    let attempt = 0
    const response = await fetch(`${api.baseURL}asistencia/sync-central`, {
      method: 'POST',
      body: JSON.stringify({ cliente: '923' }),
      headers: headers
    }).then((res) => {
      attempt++
      console.log(`Attempt ${attempt}`)
      return res
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data: SyncResponse = await response.json()
    return data
  } catch (error) {
    return rejectWithValue(error)
  }
})
